<template>
  <el-dialog
    class="dialog-automv"
    :visible.sync="openAutoMVCreation"
    width="80%"
    :close-on-click-modal="false"
    @close="onClose"
  >
    <el-card>
      <div>
        <div class="flex-col-AutoMV">
          <el-image
            style="
              width: 150px;
              height: 150px;
              border-radius: 100px;
              margin-left: 35px;
            "
            :src="this.currentUser.ImageUrl"
          ></el-image>
          <h3 style="margin-left: 20px">
            {{ this.currentUser.FullName }}
          </h3>
        </div>

        <div class="overlap-group6-AutoMV">
          <div class="rectangle-3-AutoMV"></div>
          <h1 class="titleAutoMV">{{ title }}</h1>
          <h4 class="ActualDate-AutoMV">
            {{ ActualDate }}
          </h4>
          <div class="rectangle-4-AutoMV"></div>
        </div>

        <!-- <div style="display: flex; float: right">
          <h3 style="margin-left: 20px">
            {{ "Porcetanje de la semana: " + percetangeWeek + "%" }}
          </h3>
          <h3 style="margin-left: 20px">
            {{ "Porcetanje total : " + percetangeTotal + "%" }}
          </h3>
        </div> -->

        <el-form
          label-position="top"
          :model="AutoMVFormModel"
          :rules="ruleAutoMVFormModel"
          ref="ruleForm"
          style="margin-top: 70px"
        >
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
              label="Estrategico"
              name="first"
              value="1"
            ></el-tab-pane>
            <el-tab-pane
              label="Operacionales"
              name="second"
              value="2"
            ></el-tab-pane>
          </el-tabs>

          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: end;
              margin-bottom: 5px;
              width: 100%;
            "
          >
            <div style="display: flex; float: right">
              <h3>
                {{
                  indexTabs === "1"
                    ? "Porcentaje de la semana: " +
                      totalPorcentaje(percetangeWeekOperacional) +
                      "% "
                    : "Porcentaje de la semana: " +
                      totalPorcentaje(percetangeWeekEstrategico) +
                      "% : "
                }}
              </h3>

              <h3
                style="
                  margin-left: 20px;
                  color: green;
                  background-color: rgba(87, 255, 29, 0.1);
                "
              >
                {{
                  indexTabs === "1"
                    ? "Cerrada a tiempo: " + taksClosedOnTimeOperacional.length
                    : "Cerrada a tiempo: " + taksClosedOnTimeEstrategico.length
                }}
              </h3>
              <!-- <h3
                style="
                  margin-left: 20px;
                  color: green;
                  background-color: rgba(87, 255, 29, 0.1);
                "
              >
                {{
                  indexTabs === "1"
                    ? "Abierta a tiempo: " + taksOpenOnTimeOperacional.length
                    : "Abierta a tiempo: " + taksOpenOnTimeEstrategico.length
                }}
              </h3> -->

              <h3
                style="
                  margin-left: 20px;
                  color: red;
                  background-color: rgba(255, 29, 29, 0.1);
                "
              >
                {{
                  indexTabs === "1"
                    ? "Cerrada Retrasada: " +
                      taskCloseOnLateOnWeekOperacional.length
                    : "Cerrada Retrasada: " +
                      taskCloseOnLateOnWeekEstrategico.length
                }}
              </h3>
              <h3
                style="
                  margin-left: 20px;
                  color: red;
                  background-color: rgba(255, 29, 29, 0.1);
                "
              >
                {{
                  indexTabs === "1"
                    ? "Abierta Retrasada: " +
                      taskOpenOnLateOnWeekOperacional.length
                    : "Abierta Retrasada: " +
                      taskOpenOnLateOnWeekEstrategico.length
                }}
              </h3>
            </div>

            <div style="display: flex; float: right">
              <h3>
                {{
                  indexTabs === "1"
                    ? "Porcetanje total : " +
                      totalPorcentaje(percetangeTotalOperacional) +
                      "% "
                    : "Porcetanje total : " +
                      totalPorcentaje(percetangeTotalEstrategico) +
                      "% :"
                }}
              </h3>
              <h3
                style="
                  margin-left: 20px;
                  color: green;
                  background-color: rgba(87, 255, 29, 0.1);
                "
              >
                {{
                  indexTabs === "1"
                    ? "Cerrada a tiempo: " +
                      totalTaksClosedOnTimeOperacional.length
                    : "Cerrada a tiempo: " +
                      totalTaksClosedOnTimeEstrategico.length
                }}
              </h3>
              <!-- <h3
                style="
                  margin-left: 20px;
                  color: green;
                  background-color: rgba(87, 255, 29, 0.1);
                "
              >
                {{
                  indexTabs === "1"
                    ? "Abierta a tiempo: " + totalTaksOpenOnTimeOperacional.length
                    : "Abierta a tiempo: " + totalTaksOpenOnTimeEstrategico.length
                }}
              </h3> -->

              <h3
                style="
                  margin-left: 20px;
                  color: red;
                  background-color: rgba(255, 29, 29, 0.1);
                "
              >
                {{
                  indexTabs === "1"
                    ? "Cerrada Retrasada: " +
                      totalTaksClosedOnLateOperacional.length
                    : "Cerrada Retrasada: " +
                      totalTaksClosedOnLateEstrategico.length
                }}
              </h3>
              <h3
                style="
                  margin-left: 20px;
                  color: red;
                  background-color: rgba(255, 29, 29, 0.1);
                "
              >
                {{
                  indexTabs === "1"
                    ? "Abierta Retrasada: " +
                      totalTaksOpenOnLateOperacional.length
                    : "Abierta Retrasada: " +
                      totalTaksOpenOnLateEstrategico.length
                }}
              </h3>
            </div>
          </div>
          <!-- 
          <div
            style="
              display: flex;
              float: right;
              margin-top: 10px;
              margin-bottom: 5px;
            "
          ></div> -->
          <div class="labels-AutoMV" style="margin-top: 30px">
            <div class="overlap-group-1">
              <div class="texts-labels-AutoMV inter-bold-white-20px">
                {{ objetivos }}
              </div>
            </div>
          </div>

          <div style="display: flex; float: right; margin-top: 10px">
            <!-- select employeeId -->

            <!-- <DirectionSelector
              v-model="directionId"
              @selection-change="handleChangeDirection"
            /> -->

            <DepartmentSelector
              v-if="this.currentUser.EmployeeId == 37"
              @selection-change="selectionChange"
              :onlyDepartment="true"
            />

            <el-select
              v-if="this.currentUser.EmployeeId == 37"
              v-loading="loading"
              v-model="responsableId"
              filterable
              clearable
              size="mini"
              placeholder="Responsable"
              @change="employeeChage"
            >
              <el-option
                v-for="item in employees"
                :key="item.EmployeeID"
                :label="item.Name"
                :value="item.EmployeeID"
              >
              </el-option>
            </el-select>

            <!-- select employeeId -->
            <el-select
              v-if="this.currentUser.EmployeeId != 37"
              v-loading="loading"
              v-model="responsableId"
              filterable
              clearable
              size="mini"
              placeholder="Responsable"
              @change="employeeChage"
            >
              <el-option
                v-for="item in employeesByDirection"
                :key="item.EmployeeID"
                :label="item.Name"
                :value="item.EmployeeID"
              >
              </el-option>
            </el-select>
          </div>

          <el-form-item label="TAREAS" style="margin-top: 70px">
            <rabbey-table-3
              :data="dataTaskTableData"
              :columns="columnTask"
              :loading="loadingForm"
              :maxheight="400"
            />
          </el-form-item>

          <el-row align="middle" class="rowTagsquil">
            <div class="labels-AutoMV">
              <div class="overlap-group-1">
                <div class="texts-labels-AutoMV inter-bold-white-20px">
                  {{ celebraciones }}
                </div>
              </div>
              <p class="label-description-AutoMV-AutoMV inter-bold-black-20px">
                {{ cosasQueCelebroY }}
              </p>
            </div>
            <el-form-item prop="CelebrationDetails">
              <el-input
                type="textarea"
                placeholder="Please input"
                v-model="AutoMVFormModel.CelebrationDetails"
                minlength="200"
                maxlength="10000"
                :autosize="{ minRows: 10, maxRows: 10 }"
                :disabled="loading"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-row>

          <el-row align="middle" class="rowTagsquil">
            <div class="labels-AutoMV">
              <div class="overlap-group-1">
                <div class="texts-labels-AutoMV inter-bold-white-20px">
                  {{ revisiones }}
                </div>
              </div>
              <p class="label-description-AutoMV inter-bold-black-20px">
                {{ cosasQueSeQuePud }}
              </p>
            </div>
            <el-form-item prop="RevitionsDetails">
              <el-input
                type="textarea"
                placeholder="Please input"
                v-model="AutoMVFormModel.RevitionsDetails"
                minlength="200"
                maxlength="10000"
                :autosize="{ minRows: 10, maxRows: 10 }"
                :disabled="loading"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-row>

          <el-row align="middle" class="rowTagsquil">
            <div class="labels-AutoMV">
              <div class="overlap-group-1">
                <div class="texts-labels-AutoMV inter-bold-white-20px">
                  {{ alertas }}
                </div>
              </div>
              <p class="label-description-AutoMV inter-bold-black-20px">
                {{ informacionesQueLl }}
              </p>
            </div>
            <el-form-item prop="AlertsDetails">
              <el-input
                type="textarea"
                placeholder="Please input"
                v-model="AutoMVFormModel.AlertsDetails"
                minlength="200"
                maxlength="10000"
                :autosize="{ minRows: 10, maxRows: 10 }"
                :disabled="loading"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-row>

          <el-row align="middle" class="rowTagsquil">
            <div class="labels-AutoMV">
              <div class="overlap-group-1">
                <div class="texts-labels-AutoMV inter-bold-white-20px">
                  {{ aprendizajes }}
                </div>
              </div>
              <p class="label-description-AutoMV inter-bold-black-20px">
                {{ momentosAja0Apl }}
              </p>
            </div>
            <el-form-item prop="LearningDetails">
              <el-input
                type="textarea"
                placeholder="Please input"
                v-model="AutoMVFormModel.LearningDetails"
                minlength="200"
                maxlength="10000"
                :autosize="{ minRows: 10, maxRows: 10 }"
                :disabled="loading"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-row>

          <el-row align="middle" class="rowTagsquil">
            <div class="labels-AutoMV">
              <div class="overlap-group-1">
                <div class="texts-labels-AutoMV inter-bold-white-20px">
                  {{ innovaciones }}
                </div>
              </div>
              <p class="label-description-AutoMV inter-bold-black-20px">
                {{ cosasQueHaraMejor0Diferente }}
              </p>
            </div>
            <el-form-item prop="Innovation">
              <el-input
                type="textarea"
                placeholder="Please input"
                v-model="AutoMVFormModel.Innovation"
                minlength="200"
                maxlength="10000"
                :autosize="{ minRows: 10, maxRows: 10 }"
                :disabled="loading"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-row>
          <el-form-item style="position: relative; float: right; top: -20px">
            <el-button @click="onClose">Cancel</el-button>
            <el-button
              :loading="loading"
              :disabled="loading"
              type="primary"
              @click="onSubmit('ruleForm')"
              >Create</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </el-dialog>
</template>

<script>
// import Frame1 from "@/views/apps/cmi/AutoMvs/CreateForm/Frame1.vue";
import tasks from "@/columns/tasksGanttAutoMVview";

import { formatDate } from "@/utils";
// import DirectionSelector from "@/components/Company/DirectionSelector.vue";
import DepartmentSelector from "@/components/Company/DepartmentSelector.vue";
export default {
  name: "CreateFigma",
  props: {
    openAutoMVCreation: {
      type: Boolean,
      default: false
    }
  },
  components: {
    // DirectionSelector
    DepartmentSelector
  },
  data() {
    return {
      activeName: "first",
      indexTabs: "0",
      columnTask: tasks,
      loading: false,
      TasktableData: [],
      directionId: 0,
      TasktIds: [],
      percetangeWeek: 0,
      percetangeTotal: 0,

      taskCloseOnTime: 0,

      percetangeWeekOperacional: 0,
      percetangeTotalOperacional: 0,
      totalTaksClosedOnTimeOperacional: [],
      totalTaksClosedOnLateOperacional: [],
      totalTaksOpenOnTimeOperacional: [],
      totalTaksOpenOnLateOperacional: [],

      taksClosedOnTimeOperacional: [],
      taskCloseOnLateOnWeekOperacional: [],
      taksOpenOnTimeOperacional: [],
      taskOpenOnLateOnWeekOperacional: [],

      totalTaksClosedOnTimeEstrategico: [],
      totalTaksClosedOnLateEstrategico: [],
      totalTaksOpenOnTimeEstrategico: [],
      totalTaksOpenOnLateEstrategico: [],

      taksClosedOnTimeEstrategico: [],
      taskCloseOnLateOnWeekEstrategico: [],
      taksOpenOnTimeEstrategico: [],
      taskOpenOnLateOnWeekEstrategico: [],

      percetangeWeekEstrategico: 0,
      percetangeTotalEstrategico: 0,
      loadingForm: false,
      dataTaskTableData: [],

      departmentId: null,

      responsableId: "",
      employees: [],
      employeesByDirection: [],

      image7: "image-7.png",
      objetivos: "OBJETIVOS",
      title: "AutoMV",
      semanaDel01AlOGEne2623: "Semana del 01 al 06 ENE 2023",
      celebraciones: "CELEBRACIONES",
      cosasQueCelebroY: "Cosas que celebro y me hacen feliz de haber logrado.",
      revisiones: "REVISIONES",
      cosasQueSeQuePud: "Cosas que se que pude hacer mejor o no hice bien.",
      alertas: "ALERTAS",
      informacionesQueLl:
        "Informaciones que llaman mi atención y debo actuar sobre ellas.",
      aprendizajes: "APRENDIZAJES",
      momentosAja0Apl:
        "Momentos 'AJA' o aplicaciones de conceptos que me dieron productividad.",
      innovaciones: "INNOVACIONES",
      cosasQueHaraMejor0Diferente: "Cosas que haria mejor o diferente.",
      AutoMVFormModel: {
        CelebrationDetails: "",
        RevitionsDetails: "",
        AlertsDetails: "",
        LearningDetails: "",
        Innovation: ""
      },
      ruleAutoMVFormModel: {
        CelebrationDetails: [
          {
            required: true,
            message: "Debes de llenar este campo",
            trigger: "blur"
          },
          {
            min: 100,
            message: "El mínimo de caracteres es de 100",
            trigger: "blur"
          }
        ],
        RevitionsDetails: [
          {
            required: true,
            message: "Debes de llenar este campo",
            trigger: "blur"
          },
          {
            min: 100,
            message: "El mínimo de caracteres es de 100",
            trigger: "blur"
          }
        ],
        AlertsDetails: [
          {
            required: true,
            message: "Debes de llenar este campo",
            trigger: "blur"
          },
          {
            min: 100,
            message: "El mínimo de caracteres es de 100",
            trigger: "blur"
          }
        ],
        LearningDetails: [
          {
            required: true,
            message: "Debes de llenar este campo",
            trigger: "blur"
          },
          {
            min: 100,
            message: "El mínimo de caracteres es de 100",
            trigger: "blur"
          }
        ],
        Innovation: [
          {
            required: true,
            message: "Debes de llenar este campo",
            trigger: "blur"
          },
          {
            min: 100,
            message: "El mínimo de caracteres es de 100",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    ActualDate() {
      let actualDate = formatDate(new Date(), "DD/MM/YYYY");
      return actualDate;
    }
  },
  mounted() {
    this.GetEmployeeBySupervisor();
    this.getEmployees();
  },
  methods: {
    async handleClick(tab) {
      this.indexTabs = tab.index;
      await this.getTasks();
    },
    handleChangeDirection(directionId) {
      this.directionId = directionId;
    },
    onClose() {
      this.$emit("onClose", this.openAutoMVCreation);
      this.TasktableData = [];
      this.TasktIds = [];
    },
    async onSubmit(ruleForm) {
      this.$refs[ruleForm].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          // console.log("onSubmit form: ", this.AutoMVFormModel);

          // var tId = JSON.stringify(this.TasktIds);
          let params = {
            OwnerUserId: this.currentUser.UserID,
            Celebrations: this.AutoMVFormModel.CelebrationDetails,
            Revisions: this.AutoMVFormModel.RevitionsDetails,
            Alerts: this.AutoMVFormModel.AlertsDetails,
            Learnings: this.AutoMVFormModel.LearningDetails,
            Innovation: this.AutoMVFormModel.Innovation,
            // TasktIds: tId,
            TotalPercentage: this.percetangeTotal,
            WeekPercentage: this.percetangeWeek,
            EmployeeId: this.currentUser.EmployeeId
            // TasktIds: this.TasktIds.toString()
          };

          await this.$http
            .post("/api/CMI/AutoMVs/createAutoMVs", params)
            .then((/*response*/) => {
              this.$emit("onClose");
              this.$refs[ruleForm].resetFields();
            })
            .finally(() => {
              this.loading = false;
              this.TasktIds = [];
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    totalPorcentaje(value) {
      return isNaN(value) ? 0 : value;
    },
    employeeChage() {
      this.filterDataEstrategico(this.TasktableData, this.indexTabs);
    },
    selectionChange(DepartmentID) {
      this.departmentId = DepartmentID;
      this.filterDataEstrategico(this.TasktableData, this.indexTabs);
    },
    filterDataEstrategico(dataTaskTableData, option) {
      this.loadingForm = true;
      this.dataTaskTableData = dataTaskTableData;
      const createdAt = new Date();

      if (this.departmentId != null) {
        this.dataTaskTableData = this.dataTaskTableData.filter(
          (x) => x.DeparmentID == this.departmentId
        );
      }

      if (this.responsableId != "") {
        this.dataTaskTableData = this.dataTaskTableData.filter(
          (x) => x.ResponsableId == this.responsableId
        );
      }

      if (option == 1) {
        this.TasktableDataOperacional = this.dataTaskTableData.filter(
          (data) => {
            return data.StausTasks == 1 && data.TypeStrategic === 1;
          }
        );

        //Total de datareas cerrada a tiempo
        this.totalTaksClosedOnTimeOperacional = this.dataTaskTableData.filter(
          (data) => data.StausTasks == 1 && data.TypeStrategic === 1
        );

        //Total de datareas cerrada a tiempo en la semana
        this.taksClosedOnTimeOperacional = this.dataTaskTableData.filter(
          (data) => {
            const fechaCierre = new Date(data.ClosedDate);

            var diferenciaMilisegundos = Math.abs(
              createdAt.getTime() - fechaCierre.getTime()
            );

            // Calcular la diferencia en días
            var diferenciaDias = Math.floor(
              diferenciaMilisegundos / (1000 * 60 * 60 * 24)
            );

            return (
              diferenciaDias <= 7 &&
              data.StausTasks == 1 &&
              data.TypeStrategic === 1
            );
          }
        );

        //Total de tareas cerrada retrasadas
        this.totalTaksClosedOnLateOperacional = this.dataTaskTableData.filter(
          (data) => data.StausTasks == 2 && data.TypeStrategic === 1
        );

        //Total de tareas cerrada retrasadas de la semana
        this.taskCloseOnLateOnWeekOperacional = this.dataTaskTableData.filter(
          (evento) => {
            // const fechaLimite = new Date(evento.LimiteDate);
            const fechaCierre = new Date(evento.ClosedDate);

            var diferenciaMilisegundos = Math.abs(
              createdAt.getTime() - fechaCierre.getTime()
            );

            // Calcular la diferencia en días
            var diferenciaDias = Math.floor(
              diferenciaMilisegundos / (1000 * 60 * 60 * 24)
            );

            return (
              diferenciaDias <= 7 &&
              evento.StausTasks == 2 &&
              evento.TypeStrategic === 1
            );
          }
        );

        this.totalTaksOpenOnTimeOperacional = this.dataTaskTableData.filter(
          (data) => data.StausTasks == 3 && data.TypeStrategic === 1
        );

        this.taksOpenOnTimeOperacional = this.dataTaskTableData.filter(
          (evento) => {
            const fechaLimite = new Date(evento.LimiteDate);

            var diferenciaMilisegundos = Math.abs(
              createdAt.getTime() - fechaLimite.getTime()
            );

            // Calcular la diferencia en días
            var diferenciaDias = Math.floor(
              diferenciaMilisegundos / (1000 * 60 * 60 * 24)
            );

            return (
              diferenciaDias <= 7 &&
              fechaLimite >= createdAt &&
              evento.StausTasks == 3 &&
              evento.TypeStrategic === 1
            );
          }
        );

        this.totalTaksOpenOnLateOperacional = this.dataTaskTableData.filter(
          (data) => data.StausTasks == 4 && data.TypeStrategic === 1
        );

        this.taskOpenOnLateOnWeekOperacional = this.dataTaskTableData.filter(
          (evento) => {
            const fechaLimite = new Date(evento.LimiteDate);

            var diferenciaMilisegundos = Math.abs(
              createdAt.getTime() - fechaLimite.getTime()
            );

            // Calcular la diferencia en días
            var diferenciaDias = Math.floor(
              diferenciaMilisegundos / (1000 * 60 * 60 * 24)
            );

            return (
              diferenciaDias <= 7 &&
              fechaLimite <= createdAt &&
              evento.StausTasks == 4 &&
              evento.TypeStrategic === 1
            );
          }
        );

        //LOGICA PARA OPERACIONAL
        this.percetangeWeekOperacional =
          (this.taksClosedOnTimeOperacional.length /
            (this.taksClosedOnTimeOperacional.length +
              this.taskOpenOnLateOnWeekOperacional.length +
              this.taskCloseOnLateOnWeekOperacional.length)) *
          100;

        this.percetangeWeekOperacional = Math.round(
          this.percetangeWeekOperacional
        );

        this.percetangeTotalOperacional =
          (this.totalTaksClosedOnTimeOperacional
            .length /*+ this.totalTaksClosedOnLate*/ /*this.totalTaksOpenOnTime +*/ /
            (this.totalTaksOpenOnLateOperacional.length +
              this.totalTaksClosedOnTimeOperacional.length +
              this.totalTaksClosedOnLateOperacional.length)) *
          100;
        this.percetangeTotalOperacional = Math.round(
          this.percetangeTotalOperacional
        );
      } else {
        this.totalTaksClosedOnTimeEstrategico = this.dataTaskTableData.filter(
          (data) => data.StausTasks == 1 && data.TypeStrategic === 2
        );

        this.taksClosedOnTimeEstrategico = this.dataTaskTableData.filter(
          (evento) => {
            const fechaCierre = new Date(evento.ClosedDate);

            var diferenciaMilisegundos = Math.abs(
              createdAt.getTime() - fechaCierre.getTime()
            );

            // Calcular la diferencia en días
            var diferenciaDias = Math.floor(
              diferenciaMilisegundos / (1000 * 60 * 60 * 24)
            );

            return (
              diferenciaDias <= 7 &&
              evento.StausTasks == 1 &&
              evento.TypeStrategic === 2
            );
          }
        );

        // this.totalTaksClosedOnTimeEstrategico.push(d);
        this.totalTaksClosedOnLateEstrategico = this.dataTaskTableData.filter(
          (data) => data.StausTasks == 2 && data.TypeStrategic === 2
        );

        this.taskCloseOnLateOnWeekEstrategico = this.dataTaskTableData.filter(
          (evento) => {
            const fechaCierre = new Date(evento.ClosedDate);

            var diferenciaMilisegundos = Math.abs(
              createdAt.getTime() - fechaCierre.getTime()
            );

            // Calcular la diferencia en días
            var diferenciaDias = Math.floor(
              diferenciaMilisegundos / (1000 * 60 * 60 * 24)
            );

            return (
              diferenciaDias <= 7 &&
              evento.StausTasks == 2 &&
              evento.TypeStrategic === 2
            );
          }
        );

        this.totalTaksOpenOnTimeEstrategico = this.dataTaskTableData.filter(
          (data) => data.StausTasks == 3 && data.TypeStrategic === 2
        );

        this.taksOpenOnTimeEstrategico = this.dataTaskTableData.filter(
          (evento) => {
            const fechaLimite = new Date(evento.LimiteDate);

            var diferenciaMilisegundos = Math.abs(
              createdAt.getTime() - fechaLimite.getTime()
            );

            // Calcular la diferencia en días
            var diferenciaDias = Math.floor(
              diferenciaMilisegundos / (1000 * 60 * 60 * 24)
            );

            return (
              diferenciaDias <= 7 &&
              fechaLimite >= createdAt &&
              evento.StausTasks == 3 &&
              evento.TypeStrategic === 2
            );
          }
        );
        this.totalTaksOpenOnLateEstrategico = this.dataTaskTableData.filter(
          (data) => data.StausTasks == 4 && data.TypeStrategic === 2
        );

        this.taskOpenOnLateOnWeekEstrategico = this.dataTaskTableData.filter(
          (evento) => {
            const fechaLimite = new Date(evento.LimiteDate);

            var diferenciaMilisegundos = Math.abs(
              createdAt.getTime() - fechaLimite.getTime()
            );

            // Calcular la diferencia en días
            var diferenciaDias = Math.floor(
              diferenciaMilisegundos / (1000 * 60 * 60 * 24)
            );

            return (
              diferenciaDias <= 7 &&
              fechaLimite <= createdAt &&
              evento.StausTasks == 4 &&
              evento.TypeStrategic === 2
            );
          }
        );

        //LOGICA PAR ESTRATEGICO
        this.percetangeWeekEstrategico =
          (this.totalTaksClosedOnTimeEstrategico.length /
            (this.totalTaksClosedOnTimeEstrategico.length +
              this.taskOpenOnLateOnWeekEstrategico.length +
              this.taskCloseOnLateOnWeekEstrategico.length)) *
          100;
        this.percetangeWeekEstrategico = Math.round(
          this.percetangeWeekEstrategico
        );

        this.percetangeTotalEstrategico =
          (this.totalTaksClosedOnTimeEstrategico
            .length /*+ this.totalTaksClosedOnLate*/ /*this.totalTaksOpenOnTime +*/ /
            (this.totalTaksOpenOnLateEstrategico.length +
              this.totalTaksClosedOnTimeEstrategico.length +
              this.totalTaksClosedOnLateEstrategico.length)) *
          100;

        this.percetangeTotalEstrategico = Math.round(
          this.percetangeTotalEstrategico
        );
      }
      this.loadingForm = false;
    },
    async getTasks() {
      this.loading = true;
      this.loadingForm = true;

      // Obtener la fecha de inicio y fin de la semana actual
      // let taskOpenOnLateOnWeek = [];
      // Obtener la fecha de inicio y fin de la semana actual
      // let today = new Date();
      // let validateToday = today.getDay();
      // const fechaActual = new Date();
      // const primerDiaSemanaActual = new Date(
      //   fechaActual.setDate(fechaActual.getDate() - fechaActual.getDay())
      // );
      // const ultimoDiaSemanaActual = new Date(
      //   fechaActual.setDate(primerDiaSemanaActual.getDate() + 6)
      // );

      // const ultimoDiaSemanaPasada = new Date(
      //   fechaActual.setDate(primerDiaSemanaActual.getDate() - 1)
      // );

      // const primerDiaSemanaPasada = new Date(
      //   fechaActual.setDate(ultimoDiaSemanaPasada.getDate() - 6)
      // );

      const createdAt = new Date();

      await this.$http
        .get(
          `/api/CMI/Task/GetGanttTaskByResponsableAutoMV?employeeId=${
            this.currentUser.EmployeeId
          }&option=${1}`
        )
        // Get tasks with EmployeeId

        .then((resp) => {
          if (this.indexTabs === "1" || this.indexTabs === "0") {
            const uniqueIds = new Set();
            this.TasktableData = []; // Limpiar el array antes de agregar elementos

            resp.data.forEach((d) => {
              if (
                (this.indexTabs === "1" && d.TypeStrategic === 1) ||
                (this.indexTabs === "0" && d.TypeStrategic === 2)
              ) {
                if (!uniqueIds.has(d.Id)) {
                  uniqueIds.add(d.Id);
                  // this.TasktIds.push({ id: d.Id, status: 1 });
                  this.TasktableData.push(d);
                }
              }
            });
          }

          //Total de datareas cerrada a tiempo
          this.totalTaksClosedOnTimeOperacional = resp.data.filter(
            (data) => data.TypeStrategic === 1
          );

          //Total de datareas cerrada a tiempo en la semana
          this.taksClosedOnTimeOperacional = resp.data.filter((data) => {
            const fechaCierre = new Date(data.ClosedDate);

            var diferenciaMilisegundos = Math.abs(
              createdAt.getTime() - fechaCierre.getTime()
            );

            // Calcular la diferencia en días
            var diferenciaDias = Math.floor(
              diferenciaMilisegundos / (1000 * 60 * 60 * 24)
            );

            return diferenciaDias <= 7 && data.TypeStrategic === 1;
          });

          this.totalTaksClosedOnTimeEstrategico = resp.data.filter(
            (data) => data.TypeStrategic === 2
          );

          //Total de datareas cerrada a tiempo en la semana
          this.taksClosedOnTimeEstrategico = resp.data.filter((data) => {
            const fechaCierre = new Date(data.ClosedDate);

            var diferenciaMilisegundos = Math.abs(
              createdAt.getTime() - fechaCierre.getTime()
            );

            // Calcular la diferencia en días
            var diferenciaDias = Math.floor(
              diferenciaMilisegundos / (1000 * 60 * 60 * 24)
            );

            return diferenciaDias <= 7 && data.TypeStrategic === 2;
          });
        })
        .catch((err) => {
          console.log(err);
        });
      await this.$http
        .get(
          `/api/CMI/Task/GetGanttTaskByResponsableAutoMV?employeeId=${
            this.currentUser.EmployeeId
          }&option=${2}`
        )
        // Get tasks with EmployeeId
        .then((resp) => {
          // resp.data.forEach((d) => {
          //   this.TasktIds.push({ id: d.Id, status: 2 });
          //   this.TasktableData.push(d);
          // });

          if (this.indexTabs === "1") {
            resp.data.forEach((d) => {
              if (
                d.TypeStrategic === 1 &&
                !this.TasktableData.some((item) => item.Id === d.Id)
              ) {
                // this.TasktIds.push({ id: d.Id, status: 2 });
                this.TasktableData.push(d);
              }
            });
          }

          if (this.indexTabs === "0") {
            resp.data.forEach((d) => {
              if (
                d.TypeStrategic === 2 &&
                !this.TasktableData.some((item) => item.Id === d.Id)
              ) {
                // this.TasktIds.push({ id: d.Id, status: 2 });
                this.TasktableData.push(d);
              }
            });
          }

          this.totalTaksClosedOnLateOperacional = resp.data.filter(
            (data) => data.TypeStrategic === 1
          );

          //Total de tareas cerrada retrasadas de la semana
          this.taskCloseOnLateOnWeekOperacional = resp.data.filter((evento) => {
            // const fechaLimite = new Date(evento.LimiteDate);
            const fechaCierre = new Date(evento.ClosedDate);

            var diferenciaMilisegundos = Math.abs(
              createdAt.getTime() - fechaCierre.getTime()
            );

            // Calcular la diferencia en días
            var diferenciaDias = Math.floor(
              diferenciaMilisegundos / (1000 * 60 * 60 * 24)
            );

            return diferenciaDias <= 7 && evento.TypeStrategic === 1;
          });

          this.totalTaksClosedOnLateEstrategico = resp.data.filter(
            (data) => data.TypeStrategic === 2
          );

          //Total de tareas cerrada retrasadas de la semana
          this.taskCloseOnLateOnWeekEstrategico = resp.data.filter((evento) => {
            // const fechaLimite = new Date(evento.LimiteDate);
            const fechaCierre = new Date(evento.ClosedDate);

            var diferenciaMilisegundos = Math.abs(
              createdAt.getTime() - fechaCierre.getTime()
            );

            // Calcular la diferencia en días
            var diferenciaDias = Math.floor(
              diferenciaMilisegundos / (1000 * 60 * 60 * 24)
            );

            return diferenciaDias <= 7 && evento.TypeStrategic === 2;
          });
        })
        .catch((err) => {
          console.log(err);
        });

      // await this.$http
      //   .get(
      //     `/api/CMI/Task/GetGanttTaskByResponsableAutoMV?employeeId=${
      //       this.currentUser.EmployeeId
      //     }&option=${3}`
      //   )
      //   // Get tasks with EmployeeId
      //   .then((resp) => {
      //     if (this.indexTabs === "1" || this.indexTabs === "0") {
      //       this.totalTaksOpenOnTime = 0; // Reiniciar el contador

      //       resp.data.forEach((d) => {
      //         if (
      //           (this.indexTabs === "1" && d.TypeStrategic === 1) ||
      //           (this.indexTabs === "0" && d.TypeStrategic === 2)
      //         ) {
      //           if (!this.TasktableData.some((item) => item.Id === d.Id)) {
      //             // this.TasktIds.push({ id: d.Id, status: 3 });
      //             this.TasktableData.push(d);
      //           }
      //         }
      //       });
      //     }

      //     this.totalTaksOpenOnTimeOperacional = resp.data.filter(
      //       (data) => data.TypeStrategic === 1
      //     );

      //     this.taksOpenOnTimeOperacional = resp.data.filter((evento) => {
      //       const fechaLimite = new Date(evento.LimiteDate);

      //       var diferenciaMilisegundos = Math.abs(
      //         createdAt.getTime() - fechaLimite.getTime()
      //       );

      //       // Calcular la diferencia en días
      //       var diferenciaDias = Math.floor(
      //         diferenciaMilisegundos / (1000 * 60 * 60 * 24)
      //       );

      //       return (
      //         diferenciaDias <= 7 &&
      //         fechaLimite >= createdAt &&
      //         evento.TypeStrategic === 1
      //       );
      //     });

      //     this.totalTaksOpenOnTimeEstrategico = resp.data.filter(
      //       (data) => data.TypeStrategic === 2
      //     );

      //     this.taksOpenOnTimeEstrategico = resp.data.filter((evento) => {
      //       const fechaLimite = new Date(evento.LimiteDate);

      //       var diferenciaMilisegundos = Math.abs(
      //         createdAt.getTime() - fechaLimite.getTime()
      //       );

      //       // Calcular la diferencia en días
      //       var diferenciaDias = Math.floor(
      //         diferenciaMilisegundos / (1000 * 60 * 60 * 24)
      //       );

      //       return (
      //         diferenciaDias <= 7 &&
      //         fechaLimite >= createdAt &&
      //         evento.TypeStrategic === 2
      //       );
      //     });
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });

      await this.$http
        .get(
          `/api/CMI/Task/GetGanttTaskByResponsableAutoMV?employeeId=${
            this.currentUser.EmployeeId
          }&option=${4}`
        )
        // Get tasks with EmployeeId
        .then((resp) => {
          //this.totalTaksOpenOnLate = resp.data.length;
          if (this.indexTabs === "1") {
            resp.data.forEach((d) => {
              if (
                d.TypeStrategic === 1 &&
                !this.TasktableData.some((item) => item.Id === d.Id)
              ) {
                // this.TasktIds.push({ id: d.Id, status: 4 });
                this.TasktableData.push(d);
              }
            });
          }
          if (this.indexTabs === "0") {
            resp.data.forEach((d) => {
              if (
                d.TypeStrategic === 2 &&
                !this.TasktableData.some((item) => item.Id === d.Id)
              ) {
                this.TasktIds.push({ id: d.Id, status: 4 });
                this.TasktableData.push(d);
              }
            });
          }

          this.totalTaksOpenOnLateOperacional = resp.data.filter(
            (data) => data.TypeStrategic === 1
          );

          this.taskOpenOnLateOnWeekOperacional = resp.data.filter((evento) => {
            const fechaLimite = new Date(evento.LimiteDate);

            var diferenciaMilisegundos = Math.abs(
              createdAt.getTime() - fechaLimite.getTime()
            );

            // Calcular la diferencia en días
            var diferenciaDias = Math.floor(
              diferenciaMilisegundos / (1000 * 60 * 60 * 24)
            );

            return (
              diferenciaDias <= 7 &&
              fechaLimite <= createdAt &&
              evento.TypeStrategic === 1
            );
          });

          this.totalTaksOpenOnLateEstrategico = resp.data.filter(
            (data) => data.TypeStrategic === 2
          );

          this.taskOpenOnLateOnWeekEstrategico = resp.data.filter((evento) => {
            const fechaLimite = new Date(evento.LimiteDate);

            var diferenciaMilisegundos = Math.abs(
              createdAt.getTime() - fechaLimite.getTime()
            );

            // Calcular la diferencia en días
            var diferenciaDias = Math.floor(
              diferenciaMilisegundos / (1000 * 60 * 60 * 24)
            );

            return (
              diferenciaDias <= 7 &&
              fechaLimite <= createdAt &&
              evento.TypeStrategic === 2
            );
          });
        })
        .catch((err) => {
          console.log(err);
        });

      this.percetangeWeekOperacional =
        (this.taksClosedOnTimeOperacional.length /
          (this.taksClosedOnTimeOperacional.length +
            this.taskOpenOnLateOnWeekOperacional.length +
            this.taskCloseOnLateOnWeekOperacional.length)) *
        100;

      this.percetangeWeekOperacional = Math.round(
        this.percetangeWeekOperacional
      );

      this.percetangeTotalOperacional =
        (this.totalTaksClosedOnTimeOperacional
          .length /*+ this.totalTaksClosedOnLate*/ /*this.totalTaksOpenOnTime +*/ /
          (this.totalTaksOpenOnLateOperacional.length +
            this.totalTaksClosedOnTimeOperacional.length +
            this.totalTaksClosedOnLateOperacional.length)) *
        100;
      this.percetangeTotalOperacional = Math.round(
        this.percetangeTotalOperacional
      );

      this.percetangeWeekEstrategico =
        (this.taksClosedOnTimeEstrategico.length /
          (this.taskOpenOnLateOnWeekEstrategico.length +
            this.taskCloseOnLateOnWeekEstrategico.length +
            this.taksClosedOnTimeEstrategico.length)) *
        100;

      this.percetangeWeekEstrategico = Math.round(
        this.percetangeWeekEstrategico
      );

      this.percetangeTotalEstrategico =
        (this.totalTaksClosedOnTimeEstrategico.length /
          (this.totalTaksOpenOnLateEstrategico.length +
            this.totalTaksClosedOnTimeEstrategico.length +
            this.totalTaksClosedOnLateEstrategico.length)) *
        100;

      this.percetangeTotalEstrategico = Math.round(
        this.percetangeTotalEstrategico
      );

      this.loadingForm = false;
      this.loading = false;
    },
    getEmployees() {
      let uri = "";
      const company = this.currentCompany;
      const employeeId = this.currentUser.EmployeeId;

      if (this.directionId > 0) {
        uri = `/api/Employees/GetEmployeeByCriteria?DepartmentID=${this.deparmentId}&DirectionID=${this.directionId}`;
      } else {
        uri = `/api/CMI/Objetives/GetUsersObjetivos?CompanySelected=${company}&employeeid=${employeeId}`;
      }

      this.$http
        .get(uri)
        .then((response) => {
          this.employees = response.data;
        })
        .catch(() => {});
    },
    GetEmployeeBySupervisor() {
      let uri = `/api/Employees/GetEmployeeByCriteriaSupervisor?employeeid=${this.currentUser.EmployeeId}`;
      this.$http
        .get(uri)
        .then((resp) => {
          if (this.currentUser.EmployeeId != 37) {
            resp.data.user.forEach((element) => {
              this.employeesByDirection.push({
                EmployeeID: element.EmployeeID
                  ? element.EmployeeID
                  : element.Id,
                Name: element.FullName ? element.FullName : element.Name
              });
            });

            resp.data.okEmployee.forEach((element) => {
              this.employeesByDirection.push({
                EmployeeID: element.EmployeeID
                  ? element.EmployeeID
                  : element.Id,
                Name: element.FullName ? element.FullName : element.Name
              });
            });
          }
        })
        .catch((err) => {
          if (err.message.includes("404")) {
            const h = this.$createElement;
            this.$message({
              type: "info",
              //message: "Cliente no encontrado, consultelo en otra empresa"
              message: h("p", null, [
                h("span", null, "Empleado no "),
                h("i", { style: "color: teal" }, "encontrado")
              ])
            });
          } else {
            this.$alert(err.message, err.name, {
              type: "error"
            });
          }
        });
    }
  },
  watch: {
    async openAutoMVCreation(val) {
      if (val) {
        await this.getTasks();
      }
    },
    TasktableData() {
      this.dataTaskTableData = this.TasktableData;
    }
  }
};
</script>
<style>
.frame-1 {
  background-color: red;
  border: 1px none;
  height: 250px;
  position: relative;
  float: right;
  width: auto;
}

.flex-row {
  align-items: flex-start;
  display: flex;
  gap: 51px;
  height: 267px;
  margin-right: 10px;
  min-width: 946px;
}

.flex-col-AutoMV {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  min-height: 267px;
  width: 224px;
}
.overlap-group-AutoMV {
  align-items: center;
  background-color: rgba(35, 132, 199, 1);
  display: flex;
  height: 42px;
  min-width: 222px;
  padding: 0 47px;
}
.objetivos-AutoMV {
  letter-spacing: 0;
  line-height: normal;
  min-height: 24px;
  min-width: 115px;
}
.overlap-group6-AutoMV {
  height: 225px;
  position: absolute;
  top: 100px;
  right: 72px;
  width: 671px;
}
.rectangle-3-AutoMV {
  background-color: rgba(35, 132, 199, 1);
  height: 147px;
  left: 72px;
  position: absolute;
  top: 0;
  width: 597px;
}
.titleAutoMV {
  color: white;
  font-family: inherit;
  font-size: 40px;
  font-weight: 700;
  left: 364px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 19px;
}
.ActualDate-AutoMV {
  color: white;
  font-family: inherit;
  font-size: 17px;
  font-weight: 700;
  left: 370px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 80px;
}
.rectangle-4-AutoMV {
  background-color: white;
  height: 211px;
  left: 55px;
  bottom: 10px;
  position: absolute;
  transform: rotate(-44.08deg);
  width: 102px;
}
.overlap-group-1 {
  align-items: center;
  background-color: rgba(35, 132, 199, 1);
  display: flex;
  height: 42px;
  min-width: 222px;
  padding: 0 27px;
}
.label-description-AutoMV {
  letter-spacing: 8;
  line-height: normal;
  margin-bottom: 4px;
  min-height: 24px;
  min-width: 494px;
  color: black;
  font-weight: bold;
  font-size: 17px;
}

.labels-AutoMV {
  align-items: flex-end;
  align-self: flex-start;
  display: flex;
  gap: 5px;
  margin-left: 23px;
  margin-bottom: 28px;
  min-width: 640px;
}
.texts-labels-AutoMV {
  color: white;
  letter-spacing: 8;
  text-align: center;
  line-height: normal;
  font-weight: bold;
  min-height: 24px;
  min-width: 168px;
}
</style>
